
export const getContentTypeIcon = (type: string): string => {
  switch (type) {
    case "image":
      return "🖼️";
    case "video":
      return "🎬";
    case "article":
      return "📄";
    case "webpage":
      return "🌐";
    case "pdf":
      return "📑";
    case "document":
      return "📝";
    case "text-highlight":
      return "📌";
    default:
      return "📄";
  }
};

export const getContentTypeName = (type: string): string => {
  switch (type) {
    case "text-highlight":
      return "Highlighted Text";
    default:
      return type.charAt(0).toUpperCase() + type.slice(1);
  }
};

// Helper function to detect if content is highlighted text
export const isHighlightedText = (item: any): boolean => {
  return item.content_type === 'text-highlight' || 
         item.metadata?.is_highlighted_text === true ||
         item.metadata?.highlight_data?.type === 'text-highlight';
};

// Helper function to get the deep link URL for content
export const getContentUrl = (item: any): string => {
  return item.metadata?.deep_link_url || item.url;
};

// Helper function to extract highlighted text from notes or metadata
export const getHighlightedText = (item: any): string | null => {
  if (!isHighlightedText(item)) return null;
  
  // Try to get from metadata first, then fall back to notes
  const highlightText = item.metadata?.highlight_data?.selection?.text || item.notes;
  
  if (!highlightText) return null;
  
  // Truncate if too long for display
  if (highlightText.length > 150) {
    return highlightText.substring(0, 147) + '...';
  }
  
  return highlightText;
};
